import React, { FC, useState } from "react";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { toast } from "react-toastify";
import { sendPasswordReset } from "services/auth"; 
import BackgroundImg from "images/login-background.jpg";

export interface PageForgotPasswordProps {
  className?: string;
}

const PageForgotPassword: FC<PageForgotPasswordProps> = ({ className = "" }) => {

  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    try {
      setIsSubmitting(true);
      await sendPasswordReset(email); 
      toast.success("Password reset instructions sent. Please check your email.");
    } catch (err: any) {
      toast.error(err.message || "Failed to send reset instructions");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className={`nc-PageForgotPassword min-h-[calc(100vh-5rem)] flex justify-center items-center ${className}`}
    >
      <Helmet>
        <title>Forgot Password || Torch Events</title>
      </Helmet>

      <div className="my-4 flex flex-col mx-4 px-4 sm:my-8 shadow-[0_10px_34px_-15px_rgba(0,0,0,0.24)] rounded sm:w-1/2 md:w-1/2 lg:w-1/3">
      <h2 className="text-black text-xl font-semibold text-center mt-5">Reset Your Password</h2>
        <div
          className="w-full min-h-[200px] p-4 bg-contain bg-no-repeat bg-center text-white rounded-t sm:rounded-l sm:rounded-tr-none"
          style={{ backgroundImage: `url(${BackgroundImg})` }}
        />

        <div className="mx-auto w-full space-y-6 py-4 px-8">
          <form onSubmit={handleSubmit} className="grid gap-6">
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">Email address</span>
              <Input
                type="email"
                placeholder="you@email.com"
                className="mt-1"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <ButtonPrimary type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : "Send Reset Link"}
            </ButtonPrimary>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PageForgotPassword;
